// extracted by mini-css-extract-plugin
export default {"container":"order-confirmation_container__T1SR7","image":"order-confirmation_image__Af3xm","glowingText":"order-confirmation_glowingText__B7RQU"};